import './Blob.scss';

const Blob = () => {
  return (
    <div className="blobContainer">

        <div className="radialGradient"></div>
        <div className="square">
            <span></span>
            <span></span>
            <span></span>
        </div>

        <div className="container">
            <div className="blobs">
                <div className="blob a">a</div>
                <div className="blob b">b</div>
                <div className="blob c">c</div>
            </div>
        </div>

        <div className="glow"></div>
    </div>
  );
};

export default Blob;